module.exports = __webpack_public_path__ + "static/media/game-controller-console-svgrepo-com.67c62d43.svg";